<template lang="pug">
y-chip.neutral200.pa-3.d-block.mb-4
  .text-xs.neutral500--text.font-semibold.mb-3 Current progress
  .d-flex.align-center.justify-lg-space-between.mb-4
    .text-sm.neutral700--text.font-semibold {{ stampCollected }} out of 10 stamps
    .text-xs.neutral700--text {{ nextRewardCount }} more to reward
  stamp-collections(success-icon-padding-vertical="5px" gift-icon-padding-vertical="4px" :stampCollected="stampCollected" :rewardsPosition="rewardsPosition")
</template>

<script>
import StampCollections from "@/components/clinic/checkout/marketing/collecting/stamps/StampCollections.vue";

export default {
  components: {
    StampCollections,
  },
  props: {
    stampCollected: {
      type: Number,
      default: 0
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    nextRewardPosition() {
      const nextReward = this.rewardsPosition.filter(reward => reward > this.stampCollected)
      return nextReward.length ? nextReward[0] : 10
    },
    nextRewardCount() {
      return this.nextRewardPosition - this.stampCollected
    },
  },
}
</script>

<style scoped>
</style>